import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExtensionFeaturesManagementService = ( createDecorator('IExtensionFeaturesManagementService'));
export { IExtensionFeaturesManagementService };
